import type { TTourFiltersState } from '@/entities/filter/store/types/tour/state';

export const tourCheckAppliedFilters = (searchState: TTourFiltersState): boolean => {
  const hasDates = Boolean(searchState.date.from || searchState.date.to);
  const hasPersons = searchState.persons > 1;
  const hasTourFormat = searchState.tourFormat?.length;
  const hasTourActivities = searchState.toursActivities?.length;
  const hasPrice = searchState.price.some((p) => p !== null);
  const hasDuration = searchState.duration.some((d) => d !== null);
  const hasComfort = searchState.comfort_type?.length;
  const hasActivityLevel = searchState.activity_level_category?.length;
  const hasAccommodation = searchState.accommodation_type?.length;
  const hasChildren = searchState.childrenAllowed;

  return Boolean(
    hasDates ||
    hasPersons ||
    hasPrice ||
    hasDuration ||
    hasChildren ||
    hasComfort ||
    hasActivityLevel ||
    hasTourActivities ||
    hasTourFormat ||
    hasAccommodation,
  );
};
